import React, { useState } from 'react';
import { styled } from '@nykaa/ui-components';

import PinkBoxIcon from 'components/Icons/PinkBox';
import { redirectAuthPage } from 'shared/helpers/auth';
import { pinkActionBoxTracking as pinkBoxActionTracking } from '@nykaa/prices-revealed-shared/utils';
import {
  PinkBoxEvents,
  PinkBoxEventSources,
} from '@nykaa/prices-revealed-shared/constants';
import Tooltip from 'components/Tooltip';
import TooltipContent from './TooltipContent';
import { defaultPinkBoxData, usePinkBoxGamoogaData } from './Notification';
import { getAppTheme } from 'App/theme';
import { useIsConfigHeader, useIsThemeHeader } from 'hooks/header';
import { getDataTestId } from 'shared/helpers';

const PinkBoxLink = styled.button`
  background: transparent;
  border: none;
  width: 48px;
  height: 48px;
  &:active {
    outline: none;
  }
`;

interface Props {
  active: boolean;
  pinkBoxUrl?: string;
  email: string;
  showPinkBox?: boolean;
}

function View({ active, pinkBoxUrl, email, showPinkBox }: Props) {
  const pinkBoxData = usePinkBoxGamoogaData() || defaultPinkBoxData;
  const isThemeHeader = useIsThemeHeader();
  const { headerTextColor } = useIsConfigHeader();
  const theme = getAppTheme();
  const [tooltipVisiblity, setTooltipVisiblity] = useState(true);
  if (active && pinkBoxUrl && showPinkBox) {
    const handleClick = (event: React.MouseEvent) => {
      event.preventDefault();
      pinkBoxActionTracking({
        action: PinkBoxEvents.GO_TO_PINK_BOX,
        pageSource: PinkBoxEventSources.HEADER,
      });

      setTimeout(() => {
        if (email) {
          window.location.href = pinkBoxUrl;
        } else {
          redirectAuthPage();
        }
      }, 150);
    };
    const customStyles = {
      ...theme.borders.border100,
      borderRadius: theme.borders.radius30,
      backgroundColor: theme.colors.surface,
      borderColor: '#d6d6d6',
    };
    const { title, params = {} } = pinkBoxData;
    const { description = '' } = params;
    const isValidRender =
      typeof title === 'string' &&
      title.length &&
      typeof description === 'string' &&
      description.length;
    const isTooltipHidden = !isValidRender || !tooltipVisiblity;
    return (
      <Tooltip
        isHidden={isTooltipHidden}
        style={customStyles}
        content={() => (
          <TooltipContent
            config={pinkBoxData}
            onCrossClick={() => setTooltipVisiblity(false)}
          />
        )}
      >
        <PinkBoxLink
          type="button"
          onClick={handleClick}
          {...getDataTestId('pinkBoxIcon')}
        >
          <PinkBoxIcon
            isLight={isThemeHeader}
            color={headerTextColor}
          />
        </PinkBoxLink>
      </Tooltip>
    );
  }

  return null;
}

export default View;
